import React, { ReactNode } from 'react';
import { useUserProfile } from '../hooks/useUserProfile';
import { UserScope } from '../types/auth.types';

interface ScopeGuardProps {
  children: ReactNode;
  requiredScopes: UserScope[];
  requireAll?: boolean;
  fallback?: ReactNode;
}

export const ScopeGuard: React.FC<ScopeGuardProps> = ({
  children,
  requiredScopes,
  requireAll = false,
  fallback = null,
}) => {
  const { hasAnyScope, hasAllScopes } = useUserProfile();

  const hasAccess = requireAll 
    ? hasAllScopes(requiredScopes)
    : hasAnyScope(requiredScopes);

  if (!hasAccess) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

interface SingleScopeGuardProps {
  children: ReactNode;
  scope: UserScope;
  fallback?: ReactNode;
}

export const SingleScopeGuard: React.FC<SingleScopeGuardProps> = ({
  children,
  scope,
  fallback = null,
}) => {
  const { hasScope } = useUserProfile();

  if (!hasScope(scope)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}; 